import {
  Agreement,
  BaseReducerState,
  Bill,
  GetAgreementsAPIResponse,
} from '../../../services'
import { ActionTypes } from '../actions'

export type GetAgreementsState = BaseReducerState & {
  data: Agreement[]
}

const getAgreementsInitialState: GetAgreementsState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const getAgreements = (
  state: GetAgreementsState = getAgreementsInitialState,
  action: { type: string; res: any }
): GetAgreementsState => {
  switch (action.type) {
    case `${ActionTypes.GET_AGREEMENTS}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_AGREEMENTS}_SUCCESS`: {
      const { success, data, message } = <GetAgreementsAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }

    case `${ActionTypes.GET_AGREEMENTS}_FAILURE`:
      const res = <GetAgreementsAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_AGREEMENTS}_RESET`:
      return { ...getAgreementsInitialState }
  }
  return state
}
